<template>
    <div class="container bg-light position-fixed top-50 start-50 translate-middle w-75 border border-danger p-3"
        style="border-radius: 10px">
        <div class="container overflow-auto w-100" style="max-height:80vh">
            <div class="container table-responsive">
                <button class="btn-close float-end mt-3" @click.prevent="close"></button>
                <h3 class="mt-3"><strong> Información previa del grupo de formas {{ this.imgFormFamilyInfo.name }}
                    </strong>
                </h3>
                <table class="table table-bordered my-auto mx-auto">
                    <tbody>
                        <tr>
                            <th>Linea:</th>
                            <td>{{ this.imgFormFamilyInfo.type }}</td>
                            <th>Orden del grupo de formas:</th>
                            <td>{{ this.imgFormFamilyInfo.imgFormFamilyOrder }}</td>
                        </tr>
                        <tr>
                            <th>Materias primas asociadas a este grupo de formas:</th>
                            <td colspan="3">{{ this.rawMaterialsAssociates }}</td>
                        </tr>
                    </tbody>
                </table>
                <h3 class="mt-3"> <strong> Editar forma </strong></h3>
                <p> <strong>Nota: </strong><mark><i>No podrá editar la línea de la compañia asociada a este grupo de
                            fromas.</i>
                    </mark></p>
                <p><mark>Además, tenga presente que luego de hacer clic en el botón "Actualizar grupo de formas", la
                        información que
                        sumistre en el siguiente espacio sutituirá por completo la información previa del grupo.</mark>
                </p>
                <p>
                    <strong>Atención: </strong><mark> <i>Los campos que se encuentren vacios al momento de hacer clic en
                            el
                            botón "Actualizar gruoo de formas", contarán como
                            modifaciones.</i></mark>
                </p>
                <div class="row aling-items-center mt-3 mb-3">
                    <div class="col-sm-1">
                        <p class="requiredFields">*</p>
                    </div>
                    <div class="col-sm-2">
                        <label for="familyname">Nuevo nombre para el grupo de formas:</label>
                    </div>
                    <div class="col-sm-3">
                        <input type="text" v-model="editFamilyname" class="form-control" id="familyname" />
                    </div>
                    <div class="col-sm-1">
                        <p class="requiredFields">*</p>
                    </div>
                    <div class="col-sm-2">
                        <label for="familyorder">Nuevo orden para el grupo de formas: </label>
                    </div>
                    <div class="col-sm-3">
                        <input type="number" v-model="editFamilyOrder" class="form-control" id="familyorder" step="1"
                            min="0" />
                    </div>
                </div>
                <div class="row aling-items-center mt-3 mb-3">
                    <div class="col-sm-1">
                        <p class="requiredFields">*</p>
                    </div>
                    <div class="col-sm-2">
                        <label for="familyImage">Nueva imágen representativa para el grupo de formas: </label>
                    </div>
                    <div class="col-sm-4">
                        <input type="file" class="form-control" id="familyImage" ref="file" @change="previewFile" />
                    </div>
                    <div class="col-sm-5 mt-2">
                        <input class="form-check-input" type="checkbox" role="switch" id="newImageFile"
                            v-model="newImageFileAvailable" />
                        <i> Mantener imágen previa del grupo de formas.</i>
                    </div>
                </div>
                <p><mark>
                        <i class="requiredFields">*</i> Ahora, seleccione aquellas familias de materia prima con las que
                        se puede frabicar el grupo de
                        formas
                        anterior.
                    </mark></p>
                <div class="row">
                    <div class="col-sm-2">
                        <input class="form-check-input" type="checkbox" role="switch" id="newRawMaterials"
                            v-model="newRawMatAvailable" />
                    </div>
                    <div class="col-sm-10">
                        <i> Mantener las familias primas con las que se puede fabricar este grupo de formas.</i>
                    </div>
                </div>
                <div class="mt-4 mb-4 ms-4 me-4">
                    <div class="row mt-3 mb-2">
                        <div class="form-check form-switch col-sm-3 col-3">
                            <input class="form-check-input" type="checkbox" role="switch" id="rawMaterial1"
                                v-model="editRawMaterial1" @change="getRawMaterial1" />
                            <label class="form-check-label" for="rawMaterial1">Lámina metálica en Acero al Carbono
                                <i>(HR /
                                    CR /
                                    Alfajor)</i></label>
                        </div>
                        <div class="form-check form-switch col-sm-3 col-3">
                            <input class="form-check-input" type="checkbox" role="switch" id="rawMaterial3"
                                v-model="editRawMaterial3" @change="getRawMaterial3" />
                            <label class="form-check-label" for="rawMaterial3">Lámina metálica en Acero
                                Inoxidable</label>
                        </div>
                        <div class="form-check form-switch col-sm-3 col-3">
                            <input class="form-check-input" type="checkbox" role="switch" id="rawMaterial4"
                                v-model="editRawMaterial4" @change="getRawMaterial4" />
                            <label class="form-check-label" for="rawMaterial4">Lámina metálica en Aluminio</label>
                        </div>
                        <div class="form-check form-switch col-sm-3 col-3">
                            <input class="form-check-input" type="checkbox" role="switch" id="rawMaterial2"
                                v-model="editRawMaterial2" @change="getRawMaterial2" />
                            <label class="form-check-label" for="rawMaterial2">Lámina metálica en Acero al Carbono
                                <i>(Antidesgaste)</i></label>
                        </div>
                    </div>
                </div>
                <div class="row mt-3 mb-2">
                    <div class="form-check form-switch col-sm-3 col-3">
                        <input class="form-check-input" type="checkbox" role="switch" id="rawMaterial5"
                            v-model="editRawMaterial5" @change="getRawMaterial5" />
                        <label class="form-check-label" for="rawMaterial5">Perfil estructural tipo canal en "U" en Acero
                            al
                            Carbono</label>
                    </div>
                    <div class="form-check form-switch col-sm-3 col-3">
                        <input class="form-check-input" type="checkbox" role="switch" id="rawMaterial6"
                            v-model="editRawMaterial6" @change="getRawMaterial6" />
                        <label class="form-check-label" for="rawMaterial6">Perfil estructural tipo viga en "I" en Acero
                            al
                            Carbono</label>
                    </div>
                    <div class="form-check form-switch col-sm-3 col-3">
                        <input class="form-check-input" type="checkbox" role="switch" id="rawMaterial7"
                            v-model="editRawMaterial7" @change="getRawMaterial7" />
                        <label class="form-check-label" for="rawMaterial7">Perfil estructural tipo viga en "H" en Acero
                            al
                            Carbono</label>
                    </div>
                    <div class="form-check form-switch col-sm-3 col-3">
                        <input class="form-check-input" type="checkbox" role="switch" id="rawMaterial8"
                            v-model="editRawMaterial8" @change="getRawMaterial8" />
                        <label class="form-check-label" for="rawMaterial8">Perfil estructural tipo ángulo "L" en Acero
                            al
                            Carbono e
                            Inoxidable</label>
                    </div>
                </div>
                <div class="row mt-3 mb-2">
                    <div class="form-check form-switch col-3 col-sm-3">
                        <input class="form-check-input" type="checkbox" role="switch" id="rawMaterial9"
                            v-model="editRawMaterial9" @change="getRawMaterial9" />
                        <label class="form-check-label" for="rawMaterial9">Tubería estructural en acero al carbono
                            <i>(HR)</i></label>
                    </div>
                    <div class="form-check form-switch col-3 col-sm-3">
                        <input class="form-check-input" type="checkbox" role="switch" id="rawMaterial10"
                            v-model="editRawMaterial10" @change="getRawMaterial10" />
                        <label class="form-check-label" for="rawMaterial10">Tubería tipo mueble en Acero al Carbono
                            <i>(CR)</i></label>
                    </div>
                </div>
            </div>
            <div>
                <button class="btn btn-danger mb-3" @click.prevent="saveChanges">
                    Actualizar grupo de formas
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
    props: {
        getImgFormFamilyId: Number,
    },
    watch: {
        getImgFormFamilyId(newVal) {
            if (newVal !== null) {
                this.getImgFormFamilyInfoById();
            }
        },
    },
    data() {
        return {
            //Info image form family 
            imgFormFamilyInfo: [],
            rawMaterialsAssociates: "",
            //Edit fields
            editFamilyname: "",
            editFamilyOrder: 0,
            imageFile: undefined,
            currentFile: undefined,
            editRawMaterial1: false,
            editRawMaterial2: false,
            editRawMaterial3: false,
            editRawMaterial4: false,
            editRawMaterial5: false,
            editRawMaterial6: false,
            editRawMaterial7: false,
            editRawMaterial8: false,
            editRawMaterial9: false,
            editRawMaterial10: false,
            editMaterials: [],
            rawPrefix: "MAT_",
            //Edit image
            newImageFileAvailable: false,
            newRawMatAvailable: false,
        }
    },
    methods: {
        previewFile(event) {
            this.imageFile = this.$refs.file.files;
            // console.log(this.imageFile);
            this.currentFile = this.imageFile.item(0);
            // console.log(this.currentFile);
        },
        getRawMaterial1() {
            this.editRawMaterial1
                ? this.editMaterials.push(this.rawPrefix + "ACERO_CARBONO")
                : console.log("Without raw mat1");
            // console.log(this.materials)
        },
        getRawMaterial2() {
            this.editRawMaterial2
                ? this.editMaterials.push(this.rawPrefix + "ANTIDESGASTE")
                : console.log("Without raw mat2");
            // console.log(this.materials)
        },
        getRawMaterial3() {
            this.editRawMaterial3
                ? this.editMaterials.push(this.rawPrefix + "INOXIDABLE")
                : console.log("Without raw mat3");
            // console.log(this.materials)
        },
        getRawMaterial4() {
            this.editRawMaterial4
                ? this.editMaterials.push(this.rawPrefix + "ALUMINIO")
                : console.log("Without raw mat4");
            // console.log(this.materials)
        },
        getRawMaterial5() {
            this.editRawMaterial5
                ? this.editMaterials.push(this.rawPrefix + "CANAL_U")
                : console.log("Without raw mat5");
            // console.log(this.materials)
        },
        getRawMaterial6() {
            this.editRawMaterial6
                ? this.editMaterials.push(this.rawPrefix + "VIGA_I")
                : console.log("Without raw mat6");
            // console.log(this.materials)
        },
        getRawMaterial7() {
            this.editRawMaterial7
                ? this.editMaterials.push(this.rawPrefix + "VIGA_H")
                : console.log("Without raw mat7");
            // console.log(this.materials)
        },
        getRawMaterial8() {
            this.editRawMaterial8
                ? this.editMaterials.push(this.rawPrefix + "ANGULO")
                : console.log("Without raw mat8");
            // console.log(this.materials)
        },
        getRawMaterial9() {
            this.editRawMaterial9
                ? this.editMaterials.push(this.rawPrefix + "ESTRUCTURAL")
                : console.log("Without raw mat9");
            // console.log(this.materials)
        },
        getRawMaterial10() {
            this.editRawMaterial10
                ? this.editMaterials.push(this.rawPrefix + "MUEBLE")
                : console.log("Without raw mat10");
            // console.log(this.materials)
        },
        async saveChanges() {
            if (this.editFamilyname == "" || this.editFamilyorder == 0) {
                alert("Campos vacios, por favor complete aquellos que son obligatorios pimero.")
            } else {
                let formData = new FormData();
                formData.append("image_form_family_id", this.getImgFormFamilyId);
                formData.append("edit_imgFormFamily_name", this.editFamilyname);
                formData.append("edit_imgFormFamily_order", this.editFamilyOrder);
                this.newImageFileAvailable ? formData.delete("edit_imgFormFamily_image") : formData.append("edit_imgFormFamily_image", this.currentFile);
                this.newRawMatAvailable ? formData.delete("edit_familyRaw_materials") : formData.append("edit_familyRaw_materials", JSON.stringify(this.editMaterials));
                try {
                    let res = await axios.post(
                        RUTA_SERVIDOR + "api/imgFormFamily/update",
                        formData,
                        {
                            headers: {
                                "Content-Type": "multipart/form-data",
                                Authorization: "Bearer " + localStorage.getItem("token"),
                            },
                        }
                    );
                    console.log(res.data);
                    if (!res.data) {
                        console.log("There has been a different error with the data.");
                    } else {
                        alert("Grupo de formas: " + this.editFamilyname + ", actualizada con exito!");
                        this.cleanFields();
                    }
                } catch (err) {
                    console.log(`There has been an error ${err}`);
                    alert("Ups, algo salio mal!");
                }
                this.close();
                location.reload();
            }

        },
        async getImgFormFamilyInfoById() {
            try {
                if (!this.getImgFormFamilyId) {
                    console.log("Image form family id not defined.");
                    return;
                }
                const res = await axios.get(RUTA_SERVIDOR + "api/imgFormFamily/get", {
                    params: {
                        imgFormFamily_id: this.getImgFormFamilyId,
                    },
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                    },
                });
                this.imgFormFamilyInfo = res.data[0];
                console.log(this.imgFormFamilyInfo);
                const convertRawMats = this.imgFormFamilyInfo.rawMaterials.map(this.convertRawMaterials);
                //console.log(convertRawMats);
                this.rawMaterialsAssociates = convertRawMats.join(', ');
            } catch (err) {
                console.log(`An error has occurred: ${err}`);
            }
        },
        close() {
            this.imgFormFamilyInfo = [];
            this.imgFormFamilyName = "";
            this.$emit("hideEditFormFamily", false);
        },
        convertRawMaterials(rawMaterials) {
            // Hacer un mapeo de los valores
            switch (rawMaterials) {
                case "MAT_ACERO_CARBONO":
                    return "Lámina en acero al carbono (HR / CR / Alfajor)";
                case "MAT_INOXIDABLE":
                    return "Lámina metálica en acero inoxidable";
                case "MAT_ALUMINIO":
                    return "Lámina metálica en aluminio";
                case "MAT_ANTIDESGASTE":
                    return "Lámina metálica en acero al carbono (Antidesgaste)";
                case "MAT_CANAL_U":
                    return "Perfil estructural tipo canal en 'U' en acero al carbono";
                case "MAT_VIGA_I":
                    return "Perfil estructural tipo viga en 'I' en acero al carbono";
                case "MAT_VIGA_H":
                    return "Perfil estructural tipo viga en 'H' en acero al carbono";
                case "ANGULO":
                    return "Perfil estructural tipo ángulo 'L' en acero al carbono e inoxidable";
                case "ESTRUCTURAL":
                    return "Tubería estructural en acero al carbono (HR)";
                case "MUEBLE":
                    return "Tubería tipo mueble en acero al carbono (CR)";
                default:
                    return rawMaterials; // Si no se encuentra, devolver el valor original
            }
        },
        cleanFields() {
            this.editFamilyOrder = 0;
            this.editFamilyname = "";
            this.editMaterials = [];
        }
    },
}
</script>
<style scoped>
.requiredFields {
    color: #9d0e15;
}
</style>